import _ from 'lodash';

const cardConfig = {
  green: { single: 4, double: 3 },
  red: { single: 3, double: 3 },
  purple: { single: 3, double: 3 },
  blue: { single: 4, double: 3 },
  yellow: { single: 4, double: 3 },
  orange: { single: 4, double: 3 }
};

const cardImages = {
  red: ["red-block-1.png", "red-block-2.png"],
  orange: ["orange-block-1.png", "orange-block-2.png"],
  yellow: ["yellow-block-1.png", "yellow-block-2.png"],
  green: ["green-block-1.png", "green-block-2.png"],
  blue: ["blue-block-1.png", "blue-block-2.png"],
  purple: ["purple-block-1.png", "purple-block-2.png"],
  peanut: ["peanut.card.png"],
  purpleLollipop: ["purple-swirl-card.png"],
  peppermintCandy: ["peppermint-card.png"],
  chocolateIceCream: ["ice-cream-card.png"]
};

function createCards() {
  const cards = [];
  
  // Create color cards according to the configuration
  Object.entries(cardConfig).forEach(([color, counts]) => {
    for (let i = 0; i < counts.single; i++) {
      cards.push({
        color,
        number: 1,
        display: `${color} block (single)`,
        isFlipped: false,
        image: `${process.env.PUBLIC_URL}/${cardImages[color][0]}`
      });
    }
    for (let i = 0; i < counts.double; i++) {
      cards.push({
        color,
        number: 2,
        display: `${color} block (double)`,
        isFlipped: false,
        image: `${process.env.PUBLIC_URL}/${cardImages[color][1]}`
      });
    }
  });

  // Special cards
  const specialSquares = [
    { key: "peanut", display: "Peanut Brittle" },
    { key: "purpleLollipop", display: "Purple Lollipop" },
    { key: "peppermintCandy", display: "Peppermint Candy" },
    { key: "chocolateIceCream", display: "Chocolate Ice Cream" }
  ];

  specialSquares.forEach((special) => {
    cards.push({
      color: special.key,
      number: null,
      display: special.display,
      isFlipped: false,
      image: `${process.env.PUBLIC_URL}/${cardImages[special.key][0]}`
    });
  });

  return _.shuffle(cards);
}

class Deck {
  constructor() {
    this.reset();
  }

  reset() {
    // Create fresh shuffled cards every time
    this.drawPile = createCards();  // This includes _.shuffle() internally
    this.discardPile = [];
  }

  draw() {
    if (this.drawPile.length === 0) {
      if (this.discardPile.length === 0) {
        return null;
      }
      this.drawPile = _.shuffle([...this.discardPile]);
      this.discardPile = [];
    }

    const card = this.drawPile.pop();
    this.discardPile.push(card);
    return card;
  }

  shuffle() {
    this.reset();
    return this.drawPile.length;
  }

  getRemainingCards() {
    return this.drawPile.length;
  }
}

export default Deck;
